import { MarketingGoalTargets } from "@sp-crm/core";
import { goalMetricBarColor } from "./pace";

//creating a type for the allowed DisplayMetric values so we can enforce this limitation throughout.
export const displayMetrics = [
    "visit",
    "otherTouchpoints",
    "referrals",
    "careStarts",
] as const;
export type DisplayMetric = (typeof displayMetrics)[number];

//the otherTouchpoints metric rolls calls, texts, and emails together; users read it as "Other Activities".
export const otherActivitiesLabel = "Other Activities";

//easy way to look up the same properties for both actuals & targets.
export const otherTouchpointsTotal = (targets: MarketingGoalTargets): number =>
    targets.call + targets.text + targets.email;

export const displayMetricValue = (
    targets: MarketingGoalTargets,
    metric: DisplayMetric,
): number =>
    metric === "otherTouchpoints" ? otherTouchpointsTotal(targets) : targets[metric];

export const displayMetricBarColor: Record<DisplayMetric, string> = {
    visit: goalMetricBarColor.visit,
    otherTouchpoints: "bg-indigo-600",
    referrals: goalMetricBarColor.referrals,
    careStarts: goalMetricBarColor.careStarts,
};
